export const DEBUGGING = process.env.NODE_ENV !== 'production';
export const IS_PRODUCTION = window.location.hostname.slice(0, 3) === 'app';
export const SHRUGGIE = String.raw`¯\_(ツ)_/¯`;
export const TABLE_FLIP = String.raw`(╯°□°)╯︵ ┻━┻`;

const useLocalPort = true;
export const LOCAL_PORT = useLocalPort ? ':3000' : '';
export const LEGACY_LOCAL_PORT = useLocalPort ? ':8000' : '';

/**
 * Global path prefix
 */
export const GLOBAL_PATH_PREFIX = '/r';
export const LEGACY_PATH_PREFIX = '/#';

/**
 * API constants
 */
export const API_POPIN_PREFIX = `/popin/api/1.0`;
export const API_V2_PREFIX = `/api`;
export const API_DASH_PREFIX = `${API_POPIN_PREFIX}/dash`;
export const API_PDF_PREFIX = `/popin/pdf`;
export const APP_ID = 'com.popinnow.boromir';
export const APP_BID = 'ae21e1d2c4fbc95b57864ce16a117343dd981b6c';
let APP_TYPE_TEMP;
if (DEBUGGING) {
  APP_TYPE_TEMP = 'local';
} else if (IS_PRODUCTION) {
  APP_TYPE_TEMP = 'prod';
} else {
  APP_TYPE_TEMP = 'dev';
}
export const APP_TYPE = APP_TYPE_TEMP;
export const CLIENT_KEY = 'web-app-v4';

/**
 * URL Parameters
 */
export const URL_PARAM_ADMIN_BYPASS = 'admin-bypass';

/**
 * Page links
 */
export const PAGE_LINK_SUPPORT = 'http://support.popinnow.com';
export const PAGE_LINK_SLACK_INTEGRATION = 'https://app.popinnow.com/popin/slack/add-to-slack';
export const PAGE_LINK_MSTEAMS_INTEGRATION = 'https://teams.microsoft.com/l/app/923f8bc4-c1be-462c-bea7-c0ad0d4b2eeb';
export const PAGE_LINK_IT_CHECKLIST = 'https://intercom.help/popinnow/getting-started/popin-it-checklist';
export const PAGE_LINK_TEST_EMAIL_LEARN_MORE = PAGE_LINK_IT_CHECKLIST;
export const PAGE_LINK_ADMIN_ERROR = 'https://support.popinnow.com/administrator-guides/enterprise-account-owner-faqs';
export const PAGE_LINK_OWNER_ERROR = PAGE_LINK_ADMIN_ERROR;
export const PAGE_LINK_RESTRICT_ERROR = PAGE_LINK_ADMIN_ERROR;
export const PAGE_LINK_APPROVAL_ERROR = 'https://intercom.help/popinnow/user-guides/product-tutorials/approval-needed';
export const PAGE_LINK_SAML_EXPLAIN = 'http://support.popinnow.com/administrator-guides/apps-and-integrations/configuring-saml-20-single-sign-on-sso';
export const PAGE_LINK_AUTH_LEARN_MORE = PAGE_LINK_SAML_EXPLAIN;
export const PAGE_LINK_CUSTOMIZE_CREATOR_REPORT = 'https://support.popinnow.com/popin-creator-guides/how-do-i-customize-my-popin-report';
export const PAGE_LINK_SEGMENTATION_HELP = 'https://support.popinnow.com/popin-creator-guides/how-do-i-segment-my-results';
export const PAGE_LINK_RESPONSES_EMPTY = 'http://support.popinnow.com/popin-creator-guides/best-practices/how-do-i-generate-more-interest-in-my-popin';
export const PAGE_LINK_COC_EXPLAIN = 'https://support.popinnow.com/user-guides/best-practices/what-is-the-popin-user-code-of-conduct';

/**
 * Errors
 */
export const NETWORK_CODE_SESSION_CHECK_FAILED = 205;
export const NETWORK_CODE_UNAUTHORIZED = 401;
export const NETWORK_CODE_FORBIDDEN = 403;
export const NETWORK_CODE_NOT_FOUND = 404;
export const NETWORK_CODE_SERVER_ERROR = 500;

/**
 * Icons
 */
export const arrowUpIcon = 'arrow_drop_up';
export const arrowDownIcon = 'arrow_drop_down';
export const arrowUpwardIcon = 'arrow_upward';
export const arrowDownwardIcon = 'arrow_downward';
export const concurrentArrowPrevious = 'keyboard_arrow_left';
export const concurrentArrowNext = 'keyboard_arrow_right';

/**
 * Analytics
 */
export const ACTIVE_USER_TRACKING_DEBOUNCE_MINUTES = 5;

/**
 * Creator Report
 */
export const CREATOR_REPORTS_NOTEWORTHY = 'noteworthy_responses';
export const CREATOR_REPORTS_TOP_RESPONSES = 'top_responses';
export const CREATOR_REPORTS_STATISTICS = 'statistics';
export const CREATOR_REPORTS_DISTRIBUTION = 'distribution';
export const CREATOR_REPORTS_HISTORICAL_TREND = 'historical_trend';
export const CREATOR_REPORTS_COMMENT_BY_SENTIMENT = 'comment_by_sentiment';
export const CREATOR_REPORTS_SENTIMENT_BY_RATING = 'sentiment_by_rating';
export const CREATOR_REPORTS_SEGMENTATION = 'segmentation';
export const CREATOR_REPORTS_ALL_RESPONSES = 'all_responses';
export const CREATOR_REPORTS_AI_INSIGHTS = 'ai_insights';

// POPin Live campaign
export const GTM_CONVERSION_LABEL_FREE = 'Free';
export const GTM_CONVERSION_LABEL_PREMIUM_MONTHLY = 'Premium-Monthly';
export const GTM_CONVERSION_LABEL_PREMIUM_5_MONTHLY = 'Premium-5-Monthly';
export const GTM_CONVERSION_LABEL_PREMIUM_WITH_SUPPORT_MONTHLY = 'Premium-With-Support-Monthly';
export const GTM_CONVERSION_LABEL_PREMIUM_ONE_YEAR = 'Premium-One-Year';
export const GTM_CONVERSION_LABEL_ANNUAL_ELA = 'Annual-Enterprise';

// Beta
export const BETA_NEW_DASHBOARD = 'BETA: New Dashboard cards - v1';